import { PeoplePickerDialogState } from './schema/Schema';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { createStore } from 'satcheljs';

// People picker dialog store
const peoplePickerDialogState: PeoplePickerDialogState = {
    userMailboxWrapper: null,
    findControlViewState: {
        queryString: '',
        shouldShowFindResult: false,
        findResultSet: [],
        findResultType: FindResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        hasSearchedDirectory: false,
        findPeopleFeedbackManager: null,
    },
};

export const getStore = createStore<PeoplePickerDialogState>(
    'peoplePickerDialogStore',
    peoplePickerDialogState
);

export default getStore();
